import theme from "@/styles/theme";
import { Typography, Box } from "@mui/material";
import { blueGrey } from "@mui/material/colors";

type Props = {
	title: string;
	subtitle?: string;
};

export function TitleBox({ title, subtitle }: Props) {
	return (
		<Box>
			<Typography variant={"h6"} color={theme.palette.raip.main}>
				{title}
			</Typography>
			{subtitle && (
				<Typography variant={"body2"} color={blueGrey[600]}>
					{subtitle}
				</Typography>
			)}
		</Box>
	);
}
